import { AppRouter } from "@/components/router";
import { ThemeProvider } from "@material-ui/styles";
import DLTheme from "@/styles/defaultTheme";
import { ResponsiveProvider } from "@/contexts/responsiveContext";
import { HelmetProvider } from "react-helmet-async";
import { AppScriptsLauncher } from "@/components/appScriptsLauncher";

export function App() {
  return (
    <HelmetProvider>
      <AppScriptsLauncher>
        <ResponsiveProvider>
          <ThemeProvider theme={DLTheme}>
            <AppRouter />
          </ThemeProvider>
        </ResponsiveProvider>
      </AppScriptsLauncher>
    </HelmetProvider>
  );
}
